export const mockData = {
  title: 'Единая точка доступа к финансовым данным',
  description:
    'Финансовые сервисы и дата-продукты для инвесторов, трейдеров, эмитентов, участников рынка и их подразделений',
  authButtonText: 'Зарегистрироваться',
  chooseProductButtonText: 'Выбрать продукты',
};
